/* eslint-disable */
import React from 'react';
import $ from 'jquery';
import Checkbox from '../../../common/checkbox/main';
import ConfigurationForm from './configuration_form';

export default class ConfigurationTab extends React.Component {
  state = {
    enabled: this.props.brandfolder.controlled_custom_fields_enabled,
    loading: false
  };

  toggleControlledCustomFields() {
    if (!this.state.loading) {
      var postData = {
        data: {
          attributes: {
            controlled_custom_fields_enabled: !this.state.enabled
          }
        }
      };

      this.setState({ loading: true });
      $.ajax({
        type: "PUT",
        url: `/api/v4/brandfolders/${this.props.brandfolder.key}`,
        data: JSON.stringify(postData),
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("Authorization", "Bearer " + BF_Token);
        },
        success: response => {
          this.setState((prevState) => ({ enabled: !prevState.enabled, loading: false }), () => {
            if (BFG.brandfolderSettings) {
              // update brandfolder settings global so page refresh isn't needed to get new settings
              BFG.brandfolderSettings.controlled_custom_fields_enabled = this.state.enabled
            }
          });
        },
        error: response => {
          this.setState({ loading: false });
        }
      });
    }
  }

  renderControllerCustomFieldsForm() {
    if (this.state.enabled) {
      return <ConfigurationForm brandfolder_key={this.props.brandfolder.key} />;
    }
  }

  render() {
    return (
      <div className="brandfolder-settings__control-custom-fields">
        <Checkbox
          size="md"
          checked={this.state.enabled}
          toggle={() => this.toggleControlledCustomFields()}
          label={t("Control Custom Fields")}
        />
        {this.renderControllerCustomFieldsForm()}
      </div>
    );
  }
}
